import Swal from "sweetalert2";
import moment from 'moment'
import generateUniqueId from 'generate-unique-id'
import { v4 as uuidv4 } from 'uuid';

function getLocalStorageItem(item) {
  return JSON.parse(localStorage.getItem(item));
}

function setLocalStorageItem(item, value) {
  localStorage.setItem(item, JSON.stringify(value));
}
function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function isLoadingShow() {
  return Swal.isVisible();
}

function createToast(icon, title, text) {
  const toast = Swal.mixin({
    toast: true,
    position: "top",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: false,
  });

  toast.fire({
    icon: icon ? icon : "success",
    title: title,
    text: text,
  });
}

function createLoading(title, text) {
  Swal.fire({
    title: title,
    text: text,
    showCancelButton: false,
    showConfirmButton: false,
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });
}

function closeLoading() {
  Swal.clickCancel();
}

function createToastWithTimer(icon, title, text, time) {
  let timerInterval;
  Swal.fire({
    title: title,
    icon: icon ? icon : "success",
    html: `${text}${time / 1000}秒後跳轉`,
    timer: time,
    timerProgressBar: true,
    showCancelButton: false,
    showConfirmButton: false,
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
    willClose: () => {
      clearInterval(timerInterval);
    },
  })
}

function convertDate(date) {
  try {
    if (!date) {
      return '';
    }
    return moment.utc(date).local().format('YYYY/MM/DD');
  } catch (error) {
    return ''
  }
}

function convertDateTime(date) {
  try {
    if (!date) {
      return '';
    }
    return moment.utc(date).local().format('YYYY/MM/DD HH:mm');
  } catch (error) {
    return ''
  }
}

function convertLocalDateTimeToUTC(date) {
  try {
    if (!date) {
      return '';
    }
    return moment(date).local().utc().format();
  } catch (error) {
    return ''
  }
}

function convertToUTCTime(date) {
  try {
    if (!date) {
      return '';
    }
    return moment.utc(date, 'YYYY-MM-DD HH:mm');
  } catch (error) {
    return ''
  }
}

function generateId() {
  return generateUniqueId({
    length: 22,
  });
}

function generateUUID() {
   return uuidv4();
}

export default {
  getLocalStorageItem,
  setLocalStorageItem,
  delay,
  createToast,
  createLoading,
  closeLoading,
  createToastWithTimer,
  convertDate,
  convertDateTime,
  convertToUTCTime,
  convertLocalDateTimeToUTC,
  generateId,
  generateUUID,
  isLoadingShow
};
